var x = Object.defineProperty;
var N = (t, e, n) => e in t ? x(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var y = (t, e, n) => N(t, typeof e != "symbol" ? e + "" : e, n);
const P = {
  stringify: (t) => t ? "true" : "false",
  parse: (t) => /^[ty1-9]/i.test(t)
}, T = {
  stringify: (t) => t.name,
  parse: (t, e, n) => {
    const a = (() => {
      if (typeof window < "u" && t in window)
        return window[t];
      if (typeof global < "u" && t in global)
        return global[t];
    })();
    return typeof a == "function" ? a.bind(n) : void 0;
  }
}, V = {
  stringify: (t) => JSON.stringify(t),
  parse: (t) => JSON.parse(t)
}, E = {
  stringify: (t) => `${t}`,
  parse: (t) => parseFloat(t)
}, L = {
  stringify: (t) => t,
  parse: (t) => t
}, A = {
  string: L,
  number: E,
  boolean: P,
  function: T,
  json: V
};
function $(t) {
  return t.replace(
    /([a-z0-9])([A-Z])/g,
    (e, n, a) => `${n}-${a.toLowerCase()}`
  );
}
const d = Symbol.for("r2wc.render"), g = Symbol.for("r2wc.connected"), l = Symbol.for("r2wc.context"), c = Symbol.for("r2wc.props");
function _(t, e, n) {
  var C, O, j;
  e.props || (e.props = t.propTypes ? Object.keys(t.propTypes) : []), e.events || (e.events = []);
  const a = Array.isArray(e.props) ? e.props.slice() : Object.keys(e.props), v = Array.isArray(e.events) ? e.events.slice() : Object.keys(e.events), h = {}, S = {}, m = {}, w = {};
  for (const s of a) {
    h[s] = Array.isArray(e.props) ? "string" : e.props[s];
    const u = $(s);
    m[s] = u, w[u] = s;
  }
  for (const s of v)
    S[s] = Array.isArray(e.events) ? {} : e.events[s];
  class k extends HTMLElement {
    constructor() {
      super();
      y(this, j, !0);
      y(this, O);
      y(this, C, {});
      y(this, "container");
      e.shadow ? this.container = this.attachShadow({
        mode: e.shadow
      }) : this.container = this, this[c].container = this.container;
      for (const r of a) {
        const p = m[r], o = this.getAttribute(p), i = h[r], f = i ? A[i] : null;
        f != null && f.parse && o && (this[c][r] = f.parse(o, p, this));
      }
      for (const r of v)
        this[c][r] = (p) => {
          const o = r.replace(/^on/, "").toLowerCase();
          this.dispatchEvent(
            new CustomEvent(o, { detail: p, ...S[r] })
          );
        };
    }
    static get observedAttributes() {
      return Object.keys(w);
    }
    connectedCallback() {
      this[g] = !0, this[d]();
    }
    disconnectedCallback() {
      this[g] = !1, this[l] && n.unmount(this[l]), delete this[l];
    }
    attributeChangedCallback(r, p, o) {
      const i = w[r], f = h[i], b = f ? A[f] : null;
      i in h && (b != null && b.parse) && o && (this[c][i] = b.parse(o, r, this), this[d]());
    }
    [(j = g, O = l, C = c, d)]() {
      this[g] && (this[l] ? n.update(this[l], this[c]) : this[l] = n.mount(
        this.container,
        t,
        this[c]
      ));
    }
  }
  for (const s of a) {
    const u = m[s], r = h[s];
    Object.defineProperty(k.prototype, s, {
      enumerable: !0,
      configurable: !0,
      get() {
        return this[c][s];
      },
      set(p) {
        this[c][s] = p;
        const o = r ? A[r] : null;
        if (o != null && o.stringify) {
          const i = o.stringify(p, u, this);
          this.getAttribute(u) !== i && this.setAttribute(u, i);
        } else
          this[d]();
      }
    });
  }
  return k;
}
export {
  _ as default
};
